import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema as schemaYup } from '@/pages/signUp/signUpCode/yupCodeFields';
import React, { ReactElement } from 'react';
import { UserSignConfirmCode } from '../SignUpInterface';

export const SignUpCodeController = () => {
  const schema = schemaYup();
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<UserSignConfirmCode>({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const controlledTextView = (children: ReactElement, name: 'code') => {
    return (
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({ field }) =>
          React.cloneElement(children, {
            onValueChange: (value: string) => field.onChange(value),
            error: !!errors[name],
            helperText: errors[name]?.message,
          })
        }
      />
    );
  };

  return { isValid, controlledTextView, handleSubmit };
};
